/**
 * @NOTE contains "po2goLoaderDelay" to force all assets to load prior to initializing.
 *
 * @param p
 * @constructor
 */




var Po2go_Shopify = function (p) {
    this.config = p;
}

/**
 *  This is a prototype for the Po2go object. It contains static information (e.g., methods).
 */
Po2go_Shopify.prototype = {

    session : null,
    inrequest : 0,
    remove_id : null,
    loaded : 0,
    /**
     * called when closing transferring or navigating away
     * clean up must return TRUE to automatically transfer.
     * return false if you need to wait for something else
     * to happen then trigger transfer manually.
     *
     * @return {*}
     * @private
     */
    _cleanUp : function (po_session)
    {
        this.session = po_session;
        this.session.log('ext - _cleanUp()');
        // this.walkItemsApi();
        this.walkCookies();
        return true;
    },

    /**
     @todo need name of shopify's session cookie
     removes session relevant cookies
     */
    walkCookies : function ()
    {
        this.session.log('ext - delete cookies');
        /** @todo, may need to add more cookies once punchout session works. */
        var cookies = ['cart' /*,'_secure_session_id'*/];
        for (i = 0; i < cookies.length; i++) {
            var cookie_name = cookies[i];
            this.session.log('delete '+ cookie_name);
            this.session.deleteCookie(cookie_name);
        }
    },


    //built in call (after login)
    _postInit : function ( po_session )
    {
        this.session = po_session;
        //is this even a punchout
        if(this.session.status == 1){
            this.setupPage();
        }
    },

    /*
      overrides "Checkout" button with Transfer Cart Button
    */
    setupPage : function ()
    {
        // @todo copy checkout, hide checkout button, inject <a>transfer stuff into copied button
        // @todo add style to theme
        // config.style is used for stock classes across shopify (to hide buttons, modify UI)
        // config.custom_style

        if (this.session.status == 1) {
            if (this.loaded == 0) {
                if (jQuery("head")) {
                    this.loaded = 1;
                    jQuery("head").append("\n<style>"+ this.config.style +"</style>");
                    jQuery("head").append("\n<style>"+ this.config.custom_style +"</style>");
                }
                /** @todo potential need for modal action observers to update UI changes */
                //jQuery('#CartPopoverCont').click(function(){POSession.extension.setupPage();});
                //jQuery('#CartToggleItemCount').click(function(){POSession.extension.setupPage();});
            }
            this.updateCheckoutButton();
        }

    },

    /**
     * @note this can be overridden at the source init.
     **/
    updateCheckoutButton : function(){
        if (jQuery(this.config.checkout_selector)
            && jQuery(this.config.transfer_selector).length == 0) {
            jQuery(this.config.checkout_selector).hide();
            jQuery(this.config.checkout_selector).parent().append(this.config.transfer_btn_html);
        }
    },

    /** Add to punchout.js file if requested, use the return selector and return_btn_html
     **/
    returnToProcButton : function(){
        jQuery(this.config.return_selector).append(this.config.return_btn_html);
        console.log('return to proc button function');
    },

    transferCart : async function ()
    {
        var endpoint = "/cart.js"; //GET
        Basic.Modal.show('Preparing Cart..');
        // the cart page saves delivery notes asynchronously; without this the GET below can read a stale cart
        if (typeof window.saveCartDeadline == "function") {
            try {
                await window.saveCartDeadline();
            } catch (e) {
                console.error('Cart update error:', e);
            }
        }
        jQuery.ajaxSetup({ "cache" : false });
        jQuery.ajax(endpoint,{
            "method":"GET",
            "dataType":"json",
            'complete': jQuery.proxy(async function (info,status){
                var cartData = info.responseJSON;
                if (typeof cartData == "undefined") {
                    cartData = jQuery.parseJSON(info.responseText);
                }
                if (this.evaluateCart(cartData)) {
                  await this.session.transferCart();
                } else {
//					self.alert('an error occurred retrieving your session, please try your transfer again.');
                }
            },this)
        });
    },

    deleteCart : function (data)
    {
        var endpoint = "/cart/clear.js";
        jQuery.ajaxSetup({ "cache" : false });
        jQuery.ajax(endpoint,{
            "method" : "POST",
            "type" : "POST",
            "complete" : jQuery.proxy(function (info,status)
            {
                // this.session.transferCart();
            },this)
        })
    },
    //https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart
    evaluateCart : function (data)
    {
        this.session.cart.source = data; //the whole Shopify cart, for debugging/development purposes
        this.session.cart.total = (data['total_price'] / 100);
        //this.session.cart.tax = "";
        //this.session.cart.tax_title = "";
        //this.session.cart.shipping = "";
        //this.session.cart.shipping_title = "";
        this.session.cart.discount = (data['total_discount'] / 100);
        this.session.cart.discount_title = "";
        this.session.cart.note = data['note'] ? data['note'] : "";
        this.session.cart.attributes = data['attributes'] ? data['attributes'] : {};
        this.session.cart.comments = this.session.cart.note;

        var itemset = data.items;
        //if (typeof data.items == "object") {
        for (var i=0;i < itemset.length;i++) {
            var cartItem = itemset[i];
            cartItem.supplierid = cartItem['sku'];
            cartItem.supplierauxid = cartItem['id'];
            cartItem.unitprice = (cartItem['price'] / 100);
            cartItem.description = cartItem['product_title'] ? cartItem['product_title'] : cartItem['product_description'];
            cartItem.product_id = cartItem['product_id'];
            cartItem.variant_id = cartItem['variant_id'];
            cartItem.manufacturer = cartItem['vendor'];
            cartItem.options = cartItem['variant_options'];
            cartItem.quantity = cartItem['quantity'];
            cartItem.properties = cartItem['properties'] ? cartItem['properties'] : {};
            cartItem.comments = cartItem.properties['order_deadline_message'] ? cartItem.properties['order_deadline_message'] : "";
            // if (cartItem.variant_options.length > 0) {
            // 	for (o=0;o < cartItem.variant_options.length;o++) {
            // 		item.options[cartItem.options[o].name] = cartItem.variant_options[o];
            // 	}
            // }
            this.session.addItemToCart(cartItem)
        }
        //}

        if (this.session.cart.total > 0
            && this.session.cart.items.length > 0) {
            return true;
        }
        return false;
    }
} //End prototype


/** initiate punchout2go function **/
var po2goLoaderDelay = function ()
{
    if (typeof Po2go_Shopify != 'undefined'
        && typeof Po2go != 'undefined'
        && typeof runPo2go != 'undefined') {
        runPo2go();
    } else {
        setTimeout(po2goLoaderDelay,500);
    }
}
setTimeout(po2goLoaderDelay,100);
